import type { Supabase } from '~/types/supabase-client';
import TableService from './table.service';
import type { DbResultOk } from '~/types/database-helpers';

export class ProfilesService extends TableService<'profiles'> {
  constructor(supabase: Supabase) {
    super(supabase, 'profiles', {
      pk: 'id',
      defaultSort: { field: 'created_at', ascending: false, nullsFirst: true },
    });
  }

  public async listByStripeCustomerId(stripeCustomerId: string) {
    return await this.findAll({
      filters: [['stripe_customer_id', 'eq', stripeCustomerId]],
    });
  }

  public async getProfileDetails(id: string) {
    try {
      const profileDetailsQuery = this.supabase
        .from('profiles')
        .select(
          `
            *,
            subscriptions (*)
          `
        )
        .eq('id', id)
        .single();

      type ProfileDetails = DbResultOk<typeof profileDetailsQuery>;
      const { data, error } = await profileDetailsQuery;
      if (error) throw error;
      return { data: data as ProfileDetails, error: null };
    } catch (error: any) {
      console.error('ProfileService error :: getProfileDetails');
      console.error(error);
      // no profile found. Do not need to throw for that
      if (error?.code && error.code == 'PGRST116') {
        return { data: null, error: null };
      }
      throw createError({
        statusCode: 500,
        statusMessage: error.message,
      });
    }
  }
}
